import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PopupBlocked from 'src/images/other/popups-blocked.webp';
import UnsupportedIntroGif from 'src/images/other/nearly-there.gif';
import { useOpenItemsInNewTab, useReceiveLogic } from 'src/hooks';
import { NewsletterSubscribeForm, ReceiveModalFlow } from 'src/components';
import type { ReceiveModalFlowStep } from 'src/types';

export const ReceiveUnsupportedModal = () => {
  const { t } = useTranslation();

  const { receiveUnsupported, setReceiveUnsupported } = useReceiveLogic();

  const openItemsInNewTab = useOpenItemsInNewTab({
    page: 'Receive',
    modal: 'Unsupported Retailer Modal',
  });

  const steps: ReceiveModalFlowStep[] = [
    {
      mainImage: UnsupportedIntroGif,
      title: t('popup.receive.retailer_requires_manual_cart_loading'),
      description: t(
        'popup.receive.this_retailer_doesnt_support_automatic_cart_loading',
      ),
      primaryButtonText: t('popup.receive.load_cart_manually'),
      goToStepAfterPrimary: 1,
    },
    {
      animationStep: 1,
      title: t('popup.receive.split_cart_items_up'),
      description: t('popup.receive.first_we_need_to_split_the_cart_up'),
      primaryButtonText: t('popup.receive.split_cart_up'),
      primaryButtonFunction: openItemsInNewTab,
      goToStepAfterPrimary: 2,
    },
    {
      animationStep: 2,
      title: t('popup.receive.check_items_were_opened_as_pages'),
      description: t('popup.receive.did_your_browser_just_open_each_item'),
      primaryButtonText: t('popup.receive.yes_theyre_all_open'),
      secondaryButtonText: t('popup.receive.nope_cant_see_them_all'),
      goToStepAfterPrimary: 4,
      goToStepAfterSecondary: 3,
    },
    {
      animationStep: 3,
      title: t('popup.receive.you_may_need_to_allow_browser_pop_ups'),
      description: t('popup.receive.click_the_browsers_pops_blocked_icon'),
      primaryButtonText: t('popup.receive.ok_ive_done_this'),
      goToStepAfterPrimary: 1,
      secondaryImage: PopupBlocked,
    },
    {
      animationStep: 4,
      title: t('popup.receive.add_items_to_cart_manually'),
      description: t(
        'popup.receive.now_you_just_need_to_add_each_item_on_your_own',
      ),
      primaryButtonText: t('popup.receive.got_it_will_do'),
      primaryButtonFunction: () => {
        setReceiveUnsupported(false);
      },
      afterButtonsBlock: <NewsletterSubscribeBlock />,
    },
  ];

  return (
    <ReceiveModalFlow
      open={receiveUnsupported}
      onClose={() => setReceiveUnsupported(false)}
      steps={steps}
      customMaxWidth={580}
    />
  );
};

const NewsletterSubscribeBlock = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <p className='text-100 text-pretty text-center'>
        <Trans
          i18nKey='popup.ps_join_our_mailing_list'
          components={[
            <span
              onClick={() => setExpanded(!expanded)}
              className={`cursor-pointer text-[#1E20B3] transition-all ${expanded ? 'hover:underline' : 'underline hover:opacity-80'}`}
            ></span>,
          ]}
        />
      </p>
      {expanded && (
        <div className='flex w-full flex-col items-center justify-center gap-2'>
          <NewsletterSubscribeForm focusOnMount={true} forFooter={false} />
        </div>
      )}
    </>
  );
};
